import { createAction } from '@reduxjs/toolkit';

/** @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<string>} */
export const nativeDeepLinkReceived = createAction('NATIVE_DEEP_LINK_RECEIVED');
